import { takeLatest, takeEvery, call, put } from "redux-saga/effects";
import {
  GET_N8N_WORKFLOW,
  GET_N8N_WORKFLOW_SUCCESS,
  GET_N8N_WORKFLOW_FAILURE,
  LIST_N8N_WORKFLOWS,
  GET_N8N_EXECUTION_HISTORY,
  GET_N8N_EXECUTION_HISTORY_SUCCESS,
  GET_N8N_EXECUTION_HISTORY_FAILURE,
  LIST_N8N_WORKFLOWS_SUCCESS,
  LIST_N8N_WORKFLOWS_FAILURE,
  CREATE_N8N_WORKFLOW,
  CREATE_N8N_WORKFLOW_SUCCESS,
  CREATE_N8N_WORKFLOW_FAILURE,
  UPDATE_N8N_WORKFLOW,
  UPDATE_N8N_WORKFLOW_SUCCESS,
  UPDATE_N8N_WORKFLOW_FAILURE,
  DELETE_N8N_WORKFLOW,
  DELETE_N8N_WORKFLOW_SUCCESS,
  DELETE_N8N_WORKFLOW_FAILURE,
  EXECUTE_N8N_WORKFLOW,
  EXECUTE_N8N_WORKFLOW_SUCCESS,
  EXECUTE_N8N_WORKFLOW_FAILURE,
  LIST_N8N_CLOUD_WORKFLOWS_REQUEST,
  listN8nCloudWorkflowsSuccess,
  listN8nCloudWorkflowsFailure,
} from "../actions/n8nWorkflowActions";
import {
  getN8nWorkflowApi,
  listN8nWorkflowsApi,
  getN8nExecutionHistoryApi,
  createN8nWorkflowApi,
  updateN8nWorkflowApi,
  deleteN8nWorkflowApi,
  executeN8nWorkflowApi,
} from "../api/n8nWorkflowApi";

// Saga for getting a single workflow
function* getN8nWorkflowSaga(action) {
  try {
    const { tenantId, workflowId } = action.payload;
    const response = yield call(getN8nWorkflowApi, tenantId, workflowId);
    yield put({ type: GET_N8N_WORKFLOW_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_N8N_WORKFLOW_FAILURE, payload: error.message });
  }
}

// Saga for listing workflows
function* listN8nWorkflowsSaga(action) {
  console.log(
    `PMM - SF - listN8nWorkflowsSaga - action is: ${JSON.stringify(action)}`
  );
  try {
    console.log("=== listN8nWorkflowsSaga Debug ===");
    console.log("Action:", action);
    console.log("Action payload:", action.payload);
    console.log("Action payload type:", typeof action.payload);
    console.log("Action payload value:", JSON.stringify(action.payload));

    const { tenantId } = action.payload;
    console.log("Extracted tenantId:", tenantId);
    console.log("Extracted tenantId type:", typeof tenantId);
    console.log("Extracted tenantId value:", JSON.stringify(tenantId));

    console.log("Calling listN8nWorkflowsApi with tenantId:", tenantId);
    const response = yield call(listN8nWorkflowsApi, tenantId);
    console.log("Received workflows response:", response);
    yield put({ type: LIST_N8N_WORKFLOWS_SUCCESS, payload: response });
  } catch (error) {
    console.error("=== listN8nWorkflowsSaga Error ===");
    console.error("Error message:", error.message);
    console.error("Error stack:", error.stack);
    console.error("Full error:", error);
    yield put({ type: LIST_N8N_WORKFLOWS_FAILURE, payload: error.message });
  }
}

// Saga for creating a workflow
function* createN8nWorkflowSaga(action) {
  try {
    const response = yield call(createN8nWorkflowApi, action.payload);
    yield put({ type: CREATE_N8N_WORKFLOW_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: CREATE_N8N_WORKFLOW_FAILURE, payload: error.message });
  }
}

// Saga for updating a workflow
function* updateN8nWorkflowSaga(action) {
  try {
    const response = yield call(updateN8nWorkflowApi, action.payload);
    yield put({ type: UPDATE_N8N_WORKFLOW_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: UPDATE_N8N_WORKFLOW_FAILURE, payload: error.message });
  }
}

// Saga for deleting a workflow
function* deleteN8nWorkflowSaga(action) {
  try {
    const response = yield call(deleteN8nWorkflowApi, action.payload);
    yield put({ type: DELETE_N8N_WORKFLOW_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: DELETE_N8N_WORKFLOW_FAILURE, payload: error.message });
  }
}

// Saga for executing a workflow
function* executeN8nWorkflowSaga(action) {
  try {
    const response = yield call(executeN8nWorkflowApi, action.payload);
    yield put({ type: EXECUTE_N8N_WORKFLOW_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: EXECUTE_N8N_WORKFLOW_FAILURE, payload: error.message });
  }
}

// Saga to handle listing N8n Cloud Workflows
function* listN8nCloudWorkflowsSaga(action) {
  try {
    const workflows = yield call(listN8nWorkflowsApi, action.payload);
    yield put(listN8nCloudWorkflowsSuccess(workflows));
  } catch (error) {
    console.error("Error listing N8n Cloud Workflows:", error);
    yield put(listN8nCloudWorkflowsFailure(error));
  }
}

// Saga to handle listing N8n Cloud Execution Workflow Execution History
function* getN8nExecutionHistorySaga(action) {
  console.log(
    `PMM - SF - n8nWorkflowSaga.js - getN8nExecutionHistorySaga - action is: ${JSON.stringify(
      action
    )}`
  );
  try {
    const { tenantId, workflowId } = action.payload;
    if (!tenantId || !workflowId) {
      throw new Error("tenantId and workflowId are required");
    }
    const input = {
      tenantId,
      workflowId,
    };
    const history = yield call(getN8nExecutionHistoryApi, input);
    yield put({ type: GET_N8N_EXECUTION_HISTORY_SUCCESS, payload: history });
  } catch (error) {
    console.error("Error getting N8n Execution History:", error);
    yield put({
      type: GET_N8N_EXECUTION_HISTORY_FAILURE,
      payload: error.message || "Failed to get execution history",
    });
  }
}

// Watcher saga
export default function* watchN8nWorkflow() {
  yield takeLatest(GET_N8N_WORKFLOW, getN8nWorkflowSaga);
  yield takeLatest(LIST_N8N_WORKFLOWS, listN8nWorkflowsSaga);
  yield takeLatest(CREATE_N8N_WORKFLOW, createN8nWorkflowSaga);
  yield takeLatest(UPDATE_N8N_WORKFLOW, updateN8nWorkflowSaga);
  yield takeLatest(DELETE_N8N_WORKFLOW, deleteN8nWorkflowSaga);
  yield takeLatest(EXECUTE_N8N_WORKFLOW, executeN8nWorkflowSaga);
  yield takeEvery(LIST_N8N_CLOUD_WORKFLOWS_REQUEST, listN8nCloudWorkflowsSaga);
  yield takeLatest(GET_N8N_EXECUTION_HISTORY, getN8nExecutionHistorySaga);
}
